import { render } from "./MultiDropdown.vue?vue&type=template&id=8e2ba162&scoped=true"
import script from "./MultiDropdown.vue?vue&type=script&lang=ts"
export * from "./MultiDropdown.vue?vue&type=script&lang=ts"

import "./MultiDropdown.vue?vue&type=style&index=0&id=8e2ba162&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8e2ba162"

export default script